import React from 'react';
import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../../redux/actions'; //Import your actions
import 'materialize-css';
import '../../../styles/report.scss';

import AddReportTest from './AddReportTest';
import EditReportNote from './EditReportNote';
import FileUpload from './FileUpload';

class NodeWorkbench extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      optionSelected: props.initialOption || null
    };
  }

  componentDidMount() {
    // A note has no chooser step of its own: the editor needs a persisted
    // node to bind to, so create one up front and let switchFocus hand it back.
    if (this.state.optionSelected === 'note' && !this.props.node) {
      this.addNote();
    }
  }

  addNote() {
    let id = Date.now();

    let noteObj = {
      id: id,
      report_id: this.props.report?.id,
      note_type: 'note',
      content: '',
      component_id: this.props.component.id,
      iAm: 'note',
      position: null,
      breadcrumbs: (
        this.props.saveNode ? undefined :
        this.props.component.id === '-1' ? 
        `${this.props.report.id}.components.-1.nodes.${new Date().toLocaleString().split(',')[0]}.${id}` :
        `${this.props.report.id}.components.${this.props.component.id}.notes.${id}`
      ),
      synced: false
    };

    const afterAdd = () => {
      this.props.switchFocus(noteObj, this.props.component);
    };

    if (this.props.saveNode) {
      this.props.saveNode(noteObj, { fridge: true }, afterAdd);
      return;
    }

    this.props.updateReport(
      this.buildScaffold(noteObj),
      null,
      afterAdd
    );
  }

  buildScaffold(node) {
    let breadcrumbs = node.breadcrumbs.split('.');
    let reportId = breadcrumbs.reverse().pop();
    let reportScaffold = {
      id: reportId,
      timestamp: Math.floor(Date.now()/1000),
      ...breadcrumbs.reduce((val, key) => ({[key]: val}), {...node})
    };
   
    return reportScaffold;
  }

  close() {
    this.setState({optionSelected: null});
    this.props.close();
  }

  render() {
    if (this.props.component) {
      if (this.state.optionSelected === 'note' && !this.props.node) {
        return null;
      }

      switch (this.state.optionSelected) {

        case 'test':
          if (this.props.user?.operator) return null;
          return <AddReportTest
            component={this.props.component}
            saveNode={this.props.saveNode}
            embedded={this.props.embedded}
            close={() => this.close()}
          />
        
        case 'note':
          return <EditReportNote
            node={this.props.node}
            component={this.props.component}
            saveNode={this.props.saveNode}
            embedded={this.props.embedded}
            switchFocus={(node) => this.props.switchFocus(node, this.props.component)}
            close={() => this.close()}
          />

        case 'image':
          return <FileUpload
            component={this.props.component}
            saveNode={this.props.saveNode}
            embedded={this.props.embedded}
            switchFocus={(node) => this.props.switchFocus(node)}
            close={() => this.close()}
          /> 

        default:
          if (this.props.node) {
            return <EditReportNote
              node={this.props.node}
              component={this.props.component}
              saveNode={this.props.saveNode}
              embedded={this.props.embedded}
              switchFocus={(node) => this.props.switchFocus(node, this.props.component)}
              close={() => this.close()}
            />
          } else {
            return (
              <div class={`report-modal`} onClick={() => this.close()}>
                {!this.props.user?.operator && (
                  <button class="create-node" data-node="test" onClick={(e) => {
                    e.stopPropagation();
                    this.setState({optionSelected: 'test'})
                  }}>
                    Add Test
                  </button>
                )}
                <button class="create-node" data-node="note" onClick={(e) => {
                  e.stopPropagation();
                  this.addNote();
                }}>
                  Add Note
                </button>
                <button class="create-node" data-node="image" onClick={(e) => {
                  e.stopPropagation();
                  this.setState({optionSelected: 'image'})
                }}>
                  Attach
                </button>
              </div>
            )
          }
      }
    } else { return false }
  }
}

function mapStateToProps(state, props) {
  return {
    authToken: state.authToken,
    report: state.report,
    tests: state.testFields,
    user: state.user
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(NodeWorkbench);
